import React, { Component } from 'react'
import { Row, Col, Container, Button } from 'react-bootstrap'

class CamposProcesoCalado0 extends Component {
  render () {
    const {
      onPuestoCaladoChange,
      nombrePuestoCalado,
      onPrinterChange,
      printerName
    } = this.props

    return (
      <div>
        <Container fluid>
          <Row className='justify-content-md-center row-set-config'>
            <Col md={6} className='container-set-config'>
              <h6 className='text-set-config'>[ Seleccionar puesto de calado ]</h6>
              {nombrePuestoCalado
                ? <Button
                  className='btn-set-config'
                  variant='primary'
                  color='primary'
                  onClick={onPuestoCaladoChange}>
                  {nombrePuestoCalado}
                </Button>
                : null}

            </Col>
            <Col md={6} className='container-set-config'>
              <h6 className='text-set-config'>[ Seleccionar impresora ]</h6>
              {printerName
                ? <Button
                  className='btn-set-config'
                  variant='primary'
                  color='primary'
                  onClick={onPrinterChange}>
                  {printerName}
                </Button>
                : null}
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default CamposProcesoCalado0
